export class IndentInventoryReports {
    createdDate: string;
    indentHeaderId: number;
    departmentName: string;
    indentTo: string;
    productName: string;
    requiredDate: string;
    saleUnitQuantity: number;
    quantityOrder: number;
}